import { axiosRequest, formatE164 } from "helpers";

export const businessService = {
	sendBusiness
};

const API_URL = process.env.REACT_APP_API_URL;

function sendBusiness(model) {
	const options = {
		method: "POST",
		data: {
			...model,
			phone: formatE164(model?.phone),
		},
		params: {
			token: model?.token,
		},
		url: `${API_URL}/api/pre_applications/${model?.applicationId}/business`,
	};
	return axiosRequest(options);
}
